import React, { useMemo, useState, Fragment } from 'react'
import { Table, Input, Modal, Badge } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { NPersonal, EGetUserCollect, EGetMessage, EPostCollectInfo, EUpdateMessage } from '../../../../models/constants'
import { effect, useStore } from '../../../../dva16'
import './index.less'

export default function MessageInfo() {
  const { confirm } = Modal
  const [changePage, setChangePage] = useState(1)
  const { myMessage } = useStore(NPersonal)

  useMemo(() => {
    effect(NPersonal, EGetMessage)
  }, [])

  const TableColumns = [
    {
      title: '帖子',
      dataIndex: 'title',
      // width: 250,
      key: 'title',
      render: (data, text) => (
        <Badge
          dot={text.readAt ? false : true}
          style={{ left: '-10px' }}
          onClick={() => {
            console.log('text', text)
            operateInfo(text)
            if(!text.readAt){
              effect(NPersonal, EUpdateMessage, { id: text.id, page: changePage })
            }
          }}
        >
          <span style={{cursor: 'pointer'}}>{data}</span>
        </Badge>
      ),
    },
    {
      title: '内容',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: '通知时间',
      dataIndex: 'createdAt',
      key: 'createdAt',
    },
  ]

  function operateInfo(text) {
    // let type =
    // if (type === 'detail') {
    //   window.location.href = `#detail/${text.infoID}`
    // } else if (type === 'edit') {
    //   console.log('edit')
    // }
  }

  return (
    <div id="MyInfo">
      {myMessage ? (
        <Table
          rowKey={(record) => record.id}
          onChange={(pagination, filters, sorter, extra) => {
            setChangePage(pagination.current)
            effect(NPersonal, EGetMessage, { page: pagination.current })
          }}
          pagination={{ total: myMessage.total, current: changePage }}
          columns={TableColumns}
          dataSource={myMessage.data}
        />
      ) : null}
    </div>
  )
}
